import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sub-header" }
const _hoisted_2 = { class: "grid-item-sel" }
const _hoisted_3 = { class: "grid-item-ellipse" }
const _hoisted_4 = { class: "grid-item-desc" }
const _hoisted_5 = { class: "grid-item-save" }
const _hoisted_6 = { class: "grid-item-delete" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_form_orderable = _resolveComponent("form-orderable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.columnOverride)
        ? (_openBlock(), _createBlock(_component_b_row, {
            key: 0,
            class: "grid-container"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(), _createBlock(_component_select_input, {
                  id: "col-select-order",
                  modelValue: _ctx.state.columnOrder.tablePreferenceId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.columnOrder.tablePreferenceId) = $event)),
                  label: "Saved Columns",
                  valueField: "tablePreferenceId",
                  textField: "tablePreferenceName",
                  key: _ctx.userColumnOrders,
                  options: _ctx.userColumnOrders,
                  onChange: _ctx.setSelectedColumnOrder
                }, null, 8, ["modelValue", "options", "onChange"]))
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_b_button, {
                  size: 'sm',
                  onClick: _ctx.toggleSaveAs
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("...")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.state.show)
        ? (_openBlock(), _createBlock(_component_b_row, {
            key: 1,
            class: "grid-container"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_text_input, {
                  style: {"width":"130px"},
                  label: "Save As",
                  modelValue: _ctx.state.tmpColumnOrderName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tmpColumnOrderName) = $event)),
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_b_button, {
                  size: 'sm',
                  onClick: _ctx.saveColumnOrder
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Save")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_b_button, {
                  size: 'sm',
                  onClick: _ctx.deleteColumnOrder
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Delete")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
    ]),
    _createElementVNode("div", null, [
      (_openBlock(), _createBlock(_component_form_orderable, {
        id: "orderable-column-list",
        "model-value": _ctx.modelValue.columnDefinition,
        "dynamic-columns": _ctx.state.columnOrder.columns,
        key: _ctx.modelValue,
        onColumnChange: _ctx.columnChange,
        "column-override": _ctx.columnOverride
      }, null, 8, ["model-value", "dynamic-columns", "onColumnChange", "column-override"]))
    ])
  ], 64))
}